<template>
  <hb-section
    :title="$t('influencer_panel.tab_available')"
    :subtitle="$tc('influencer_panel.available_count', campaigns.length, { count: campaigns.length })"
  >
    <template v-if="modalities.length > 1" #actions>
      <b-form-select v-model="modality" :options="modalityOptions" size="sm" class="available__filter" />
    </template>

    <hb-empty-state
      v-if="!filtered.length"
      :title="$t('influencer_panel.no_available')"
      icon="SearchIcon"
    />

    <div v-else class="available__list">
      <div v-for="item in filtered" :key="item.id" class="available__row">
        <div class="available__identity">
          <div class="available__name">{{ item.name }}</div>
          <div class="available__entity">{{ entityLine(item) }}</div>
        </div>

        <div class="available__stat">
          <div class="available__stat-label">{{ $t('influencer_panel.commission') }}</div>
          <div class="available__stat-value">{{ campaignCommissionLabel(item) }}</div>
        </div>

        <div v-if="discountLabel(item)" class="available__stat">
          <div class="available__stat-label">{{ $t('campaign.discount') }}</div>
          <div class="available__stat-value">{{ discountLabel(item) }}</div>
        </div>

        <div class="available__stat">
          <div class="available__stat-label">{{ $t('campaign.products_count') }}</div>
          <div class="available__stat-value">{{ (item.products || []).length }}</div>
        </div>

        <div class="available__action">
          <b-button variant="primary" size="sm" @click="$emit('join', item)">
            {{ $t('influencer_panel.join') }}
          </b-button>
        </div>
      </div>
    </div>
  </hb-section>
</template>

<script>
import { BButton, BFormSelect } from 'bootstrap-vue'
import HbSection from '@/components/hubee/HbSection.vue'
import HbEmptyState from '@/components/hubee/HbEmptyState.vue'
import { entityLine, discountLabel, campaignCommissionLabel } from '../campaign'

/**
 * Campanhas abertas para o perfil do influencer.
 *
 * O filtro de modalidade so aparece quando ha mais de uma para filtrar — um seletor com
 * uma opcao so e ruido.
 */
export default {
  name: 'AvailableCampaignsPane',
  components: {
    BButton, BFormSelect, HbSection, HbEmptyState,
  },
  props: {
    campaigns: { type: Array, default: () => [] },
  },
  data: () => ({ modality: null }),
  computed: {
    modalities() {
      const names = this.campaigns
        .map(c => c.modality_name || (c.modality && c.modality.name))
        .filter(Boolean)

      return [...new Set(names)].sort()
    },
    modalityOptions() {
      return [
        { value: null, text: this.$t('influencer_panel.all_modalities') },
        ...this.modalities.map(name => ({ value: name, text: name })),
      ]
    },
    filtered() {
      if (!this.modality) return this.campaigns

      return this.campaigns.filter(
        c => (c.modality_name || (c.modality && c.modality.name)) === this.modality
      )
    },
  },
  methods: {
    discountLabel,
    campaignCommissionLabel,
    /** A campanha crua tem `legalEntity` no mesmo formato da aninhada na participacao. */
    entityLine(campaignData) {
      return entityLine({ campaign: campaignData })
    },
  },
}
</script>

<style scoped>
.available__filter {
  width: auto;
  min-width: 180px;
}

.available__row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
  padding: 0.9rem 0.75rem;
  border-bottom: 1px solid var(--border-color);
  transition: background-color var(--dur-fast) var(--ease-in-out);
}

.available__row:last-child {
  border-bottom: none;
}

.available__row:hover {
  background: var(--surface-hover);
}

.available__identity {
  flex: 1 1 220px;
  min-width: 0;
}

.available__name {
  font-weight: var(--fw-medium);
  color: var(--text-heading);
}

.available__entity {
  font-size: var(--fs-sm);
  color: var(--text-muted);
}

.available__stat {
  flex: 0 0 auto;
  min-width: 96px;
}

.available__stat-label {
  font-size: var(--fs-xs);
  color: var(--text-muted);
}

.available__stat-value {
  font-weight: var(--fw-medium);
  color: var(--text-heading);
}

.available__action {
  flex: 0 0 auto;
  margin-left: auto;
}
</style>
